import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../services/api/base';
import session from '../services/session';
import SignIn from '../pages/signin';
import { auth } from '../services/api/Auth';

interface IProps {
  children: JSX.Element;
}

const Authentication = (props: IProps): JSX.Element => {
  const currentSession = session.get();
  const history = useHistory();

  const [isPending, setIsPending] = useState<boolean>(false);

  if (currentSession) {
    return props.children;
  }
  return (
    <SignIn
      pending={isPending}
      onSubmit={async (username: string, password: string, callback: (result: any) => void) => {
        const signin = async () => {
          try {
            setIsPending(true);
            const result = await auth({ username, password });
            callback(result);

            if (result.status === 201) {
              session.set({
                username: result.data.username,
                accessToken: result.data.accessToken,
                thumbUrl: result.data.thumbUrl,
              });

              api.setAccessToken(result.data.accessToken);

              history.push('/');
            }
          } catch (e) {
            callback(e.response.data);
          } finally {
            setIsPending(false);
          }
        };

        signin();
      }}
    />
  );
};

export default Authentication;
